function changeAddToCartByttonText() {
    let addToCartShelfButton = document.querySelectorAll('.button-cart-bottom a span.text');
    let si
  
    addToCartShelfButton.forEach(function(arg, key) {
      arg.innerText = 'Adicionar ao carrinho';
       arg.innerText = 'Adicionar ao carrinho';
      
    })
    // clearInterval(si);
     
}


// window.addEventListener('load', function() {
//    changeAddToCartByttonText()
// })


$(document).on('contentUpdated', function (event) {
    changeAddToCartByttonText()
});


$('.grid-slider.js_carousel').on('change', function() {
  console.log('kcttt')
})


$('.grid-slider.js_carousel').on('shopify:section:load', function (event) {
    console.log('merdaaa')
});


window.addEventListener("visibilitychange", function() {
 changeAddToCartByttonText()
})



// Função para modificar o innerText dos elementos
function updateText(arg) {
    let btns = arg.querySelectorAll('.button-cart-bottom a span.text').forEach(function(bt) {
        //   const intervalId = setInterval(() => {
        //     bt.innerText = 'Adicionar ao carrinho';
        //     if (bt.innerText === 'Adicionar ao carrinho') {
        //         clearInterval(intervalId);
        //     }
        //     changeAddToCartByttonText()
        // }, 300);
    });
}

// Função de callback para o IntersectionObserver
function callback(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            changeAddToCartByttonText();
            updateText(entry.target);
            observer.unobserve(entry.target);
        }
    });
}

// Configura o IntersectionObserver
const observer = new IntersectionObserver(callback, {
    root: null, // viewport
    rootMargin: '0px',
    threshold: 0 // Começa a observar quando 10% do elemento está visível
});

// Seleciona todos os elementos .button-cart-bottom a span.text
const addToCartShelfButton = document.querySelectorAll('.grid-slider.js_carousel .slick-track');

// Inicia a observação de cada elemento
addToCartShelfButton.forEach(arg => observer.observe(arg));



document.querySelector('#track123-app .background .svg-container .svg').src = 'https://cdn.shopify.com/s/files/1/0694/9037/6941/files/rastreio-yvice_430xddddxx.svg?v=d1718232514#';





// document.querySelectorAll('.price span').forEach(function(arg) {
//     arg.innerHTML = arg.innerHTML.replace(/(\s)(–).*/m, '')
// })